import React from "react";
import "./Nav.css";
import { useState, useEffect } from "react";
function Nav() {
  const [show, handleShow] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 100) {
        handleShow(true);
      } else handleShow(false);
    });
    return () => {
      window.removeEventListener("scroll", "s");
    };
  }, []);

  return (
    <div className={`Nav ${show && "nav_black"} `}>
      <img
        className="nav_logo"
        src="https://upload.wikimedia.org/wikipedia/commons/0/08/Netflix_2015_logo.svg"
        alt="netflix logo"
      />
      <img
        src="https://upload.wikimedia.org/wikipedia/commons/0/0b/Netflix-avatar.png"
        className="nav__avtar"
        alt="netflix_logo"
      />
    </div>
  );
}

export default Nav;
